import type { EnrollmentStatus, GuardianRelation } from "@/types";

/** Libellés des statuts d'inscription (valeurs identiques au backend). */
export const ENROLLMENT_STATUS_LABEL: Record<EnrollmentStatus, string> = {
  ACTIVE: "Active",
  COMPLETED: "Terminée",
  CANCELLED: "Annulée",
  LEFT: "A quitté l'école",
};

export const ENROLLMENT_STATUS_TONE: Record<EnrollmentStatus, "success" | "neutral" | "accent"> = {
  ACTIVE: "success",
  COMPLETED: "neutral",
  CANCELLED: "accent",
  LEFT: "accent",
};

/** Statuts qu'on peut choisir à la main (« A quitté » se déclare avec sa date et son motif). */
export const ENROLLMENT_STATUSES = (Object.keys(ENROLLMENT_STATUS_LABEL) as EnrollmentStatus[]).filter((s) => s !== "LEFT");

/** L'élève compte dans sa classe (listes, effectifs, notes, cartes) : ni annulé, ni parti. */
export const isInClass = (status: EnrollmentStatus): boolean => status !== "CANCELLED" && status !== "LEFT";

/** Libellés des liens de parenté (valeurs identiques au backend). */
export const GUARDIAN_RELATION_LABEL: Record<GuardianRelation, string> = {
  PERE: "Père",
  MERE: "Mère",
  TUTEUR: "Tuteur",
  ONCLE: "Oncle",
  TANTE: "Tante",
  GRAND_PARENT: "Grand-parent",
  FRERE_SOEUR: "Frère / Sœur",
  AUTRE: "Autre",
};

export const GUARDIAN_RELATIONS = Object.keys(GUARDIAN_RELATION_LABEL) as GuardianRelation[];
